import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
	selector: "app-test-landing-page",
	templateUrl: "./test-landing-page.component.html",
	styleUrls: ["./test-landing-page.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TestLandingPageComponent implements OnInit {
	ngOnInit(): void {}
}
